module.exports = __webpack_public_path__ + "static/media/trust_wallet.4c6569d7.svg";